import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO";

const StaticPage = ({
  seo,
  hero,
  intro,
  sections = [],
  highlights = [],
  routes = [],
  cta
}) => {
  return (
    <div className="bg-white">
      {seo && (
        <SEO
          title={seo.title}
          description={seo.description}
          keywords={seo.keywords}
          canonicalUrl={seo.canonicalUrl}
        />
      )}

      <section className="bg-gradient-to-b from-red-50 via-white to-white">
        <div className="max-w-6xl mx-auto px-6 py-14">
          <div className="max-w-3xl">
            <p className="text-xs uppercase tracking-[0.2em] text-red-600 font-semibold">
              BookinIndia
            </p>
            <h1 className="mt-3 text-4xl md:text-5xl font-extrabold text-gray-900">
              {hero?.title}
            </h1>
            {hero?.subtitle && (
              <p className="mt-4 text-lg text-gray-600">{hero.subtitle}</p>
            )}
          </div>

          {intro && (
            <p className="mt-6 text-base text-gray-700 max-w-3xl leading-relaxed">
              {intro}
            </p>
          )}

          {highlights.length > 0 && (
            <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-4">
              {highlights.map((item) => (
                <div
                  key={item.title}
                  className="rounded-2xl border border-red-100 bg-white p-5 shadow-sm"
                >
                  <h3 className="text-sm font-semibold text-gray-900">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm text-gray-600">{item.text}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid gap-8">
          {sections.map((section) => (
            <div key={section.title} className="rounded-2xl border border-gray-100 p-6">
              <h2 className="text-2xl font-bold text-gray-900">{section.title}</h2>
              {section.text && (
                <p className="mt-3 text-gray-700 leading-relaxed">{section.text}</p>
              )}
              {section.bullets && section.bullets.length > 0 && (
                <ul className="mt-4 list-disc list-inside text-gray-700 space-y-2">
                  {section.bullets.map((bullet) => (
                    <li key={bullet}>{bullet}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </section>

      {routes.length > 0 && (
        <section className="bg-gray-50">
          <div className="max-w-6xl mx-auto px-6 py-12">
            <h2 className="text-2xl font-bold text-gray-900">Popular Routes</h2>
            <p className="mt-2 text-gray-600">
              Transparent starting fares with safe, comfortable cabs.
            </p>
            <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
              {routes.map((route) => (
                <div
                  key={route.slug}
                  className="rounded-2xl bg-white border border-gray-200 p-5"
                >
                  <div className="text-sm text-gray-500">Starting from</div>
                  <div className="text-xl font-bold text-gray-900 mt-1">
                    {route.price}
                  </div>
                  <div className="mt-3 text-base font-semibold text-gray-800">
                    {route.label}
                  </div>
                  <Link
                    to={route.slug}
                    className="inline-flex mt-4 text-sm font-semibold text-red-600 hover:text-red-700"
                  >
                    View route details
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {cta && (
        <section className="max-w-6xl mx-auto px-6 py-12">
          <div className="rounded-3xl bg-red-600 text-white p-8 md:p-12">
            <h2 className="text-2xl md:text-3xl font-bold">{cta.title}</h2>
            <p className="mt-3 text-red-50 max-w-2xl">{cta.text}</p>
            <Link
              to={cta.link}
              className="inline-flex mt-6 bg-white text-red-600 font-semibold px-6 py-3 rounded-xl hover:bg-red-50"
            >
              {cta.button}
            </Link>
          </div>
        </section>
      )}
    </div>
  );
};

export default StaticPage;
